/*
 * @Author: Liux
 * @Date: 2019-11-19 02:32:42
 * @LastEditor: Liux
 * @LastEditTime: 2019-11-25 02:35:08
 */
import {
  Component,
  OnInit,
  forwardRef,
  EventEmitter,
  Input,
  AfterContentInit,
  QueryList,
  ContentChildren
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { AdLinkMenuItem } from './ad-link-menu-item';
import { Router, ActivatedRoute } from '@angular/router';
import { AdLinkMenuItemComponent } from './ad-link-menu-item.component';

@Component({
  selector: 'ad-link-menu',
  templateUrl: './ad-link-menu.component.html',
  styleUrls: ['./ad-link-menu.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AdLinkMenuComponent),
      multi: true
    }
  ]
})
export class AdLinkMenuComponent
  implements OnInit, ControlValueAccessor, AfterContentInit {
  _selectedItem: AdLinkMenuItem;

  set selectedItem(val: AdLinkMenuItem) {
    const oldSelectedItem = this._selectedItem;
    this._selectedItem = val;
    this.valueOnChange(val);
    if (
      (!oldSelectedItem && val) ||
      (oldSelectedItem && !val) ||
      (val && oldSelectedItem && val.value !== oldSelectedItem.value)
    ) {
      this.onChange.emit({ val, event });
    }
  }

  get selectedItem() {
    return this._selectedItem;
  }

  //#region ngModel
  valueOnChange = (v: AdLinkMenuItem) => {};
  valueOnTouched = () => {};
  writeValue(obj: AdLinkMenuItem): void {
    this._selectedItem = obj;
  }
  registerOnChange(fn: any): void {
    this.valueOnChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.valueOnTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {}

  //#endregion

  //#region Define Event
  public dataBinding: EventEmitter<any> = new EventEmitter<any>();
  public dataBound: EventEmitter<any> = new EventEmitter<any>();
  public onChange: EventEmitter<any> = new EventEmitter<any>();
  public onClick: EventEmitter<any> = new EventEmitter<any>();
  //#endregion

  //#region view children
  @ContentChildren(AdLinkMenuItemComponent) linkMenuItems: QueryList<
    AdLinkMenuItemComponent
  >;
  //#endregion

  _dataSource: AdLinkMenuItem[] = [];

  @Input() set dataSource(val: AdLinkMenuItem[]) {
    this._dataSource = val;
    this.dataBinding.emit(val);
    if (!this.selectedItem) {
      this.applyDefaultSelectedItem();
    } else {
      this.checkSelectedItemIsInDataSource();
    }
    this.dataBound.emit(val);
  }

  get dataSource() {
    return this._dataSource;
  }

  applyDefaultSelectedItem() {
    const item = this.dataSource.find(i => i.selected);
    if (item !== undefined) {
      this.selectedItem = item;
    }
  }

  checkSelectedItemIsInDataSource() {
    if (
      this.selectedItem.value !== null &&
      this.selectedItem.value !== undefined
    ) {
      const matched = this.dataSource.find(
        item => item.value === this.selectedItem.value
      );
      if (!matched) {
        // it's not in the datasource, so need reset the selected item to null.
        this.selectedItem = null;
      }
    }
  }

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    this._dataSource = [];
  }

  ngAfterContentInit(): void {
    if (this.dataSource && this.dataSource.length === 0) {
      if (this.linkMenuItems && this.linkMenuItems.length > 0) {
        const ds = this.linkMenuItems.map(item => {
          const newItem = item as AdLinkMenuItem;
          return newItem;
        });
        this.dataSource = ds;
      }
    }
  }

  public setValue(val: any) {
    if (this.dataSource && this.dataSource.length > 0) {
      const matched = this.dataSource.find(item => item.value === val);
      if (matched) {
        this.selectedItem = matched;
      }
    }
  }

  itemClick(item: AdLinkMenuItem, event: any) {
    if (item) {
      this.selectedItem = item;

      this.onClick.emit({ item, event });
      if (item.action && typeof item.action === 'function') {
        item.action(item);
      } else if (item.link) {
        if (item.isExternal) {
          if (item.target === '_blank') {
            window.open(item.link);
          } else {
            window.location.href = item.link;
          }
        } else {
          this.router.navigateByUrl(item.link);
        }
      } else if (item.routerLink) {
        const urlTree = this.router.createUrlTree(item.routerLink, {
          relativeTo: this.route
        });
        this.router.navigateByUrl(urlTree);
      }
    }
  }
}
